import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const AdminInvoice = () => {
  const [stockItems, setStockItems] = useState([]);
  const [kitchenId, setKitchenId] = useState(null);
  const [requisitionList, setRequisitionList] = useState([]);
  const [formData, setFormData] = useState({ itemName: "", quantity: "" });
  const today = new Date().toISOString().split("T")[0];

  const [inputGroups, setInputGroups] = useState([
    { item: "", available: 100, quantity: "", date: today, category_item: "" },
  ]);

  const [selectedItemId, setSelectedItemId] = useState(null);
  const [REID, setSelectedREID] = useState("");
  const [REID1, setSelectedREID1] = useState("");
  const [itemDetails, setItemDetails] = useState([]);
  const [stockOptions, setStockOptions] = useState([]);
  const [stockVendor, setvendor] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [filterRequisitionDate, setRequisitionDate] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(requisitionList.length / itemsPerPage);
  const paginatedList = requisitionList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
      axios
        .get(
          `https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${user.kitchen}/`
        )
        .then((res) => {
          const formatted = res.data.map((item) => ({
            kitchenstock_id: item.kitchenstock_id,
            stock_name: item.stock_name,
            quantity: item.quantity,
            required_quantity: "",
            required_date: "",
          }));
          setStockItems(formatted);
        })
        .catch((err) => console.error("Error fetching kitchen stock:", err));
    }
  }, []);

  useEffect(() => {
    fetchRequisitionList();
  }, []);

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/admin-panel/vendor/")
      .then((res) => setvendor(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/api/stocks/")
      .then((res) => setStockOptions(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  const statusMap = {
    0: "Pending",
    1: "Approved",
    2: "Recieved",
    3: "Cancelled",
  };
  const statusColorMap = {
    0: "secondary",
    1: "warning",
    2: "success",
    3: "warning",
  };

  const fetchRequisitionItemDetails = async (pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/item-request-list/${pk}/`
      );
      setItemDetails(response.data.requisitiondataitem);
    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  console.log(inputGroups);
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/add-request-items",
        {
          items: inputGroups.map((group) => ({
            item: group.item,
            quantity: group.quantity,
            kitchenId: kitchenId,
            available: "",
            date: group.date,
            category: group.category_item,
          })),
        }
      );

      if (response.status === 200 || response.status === 201) {
        setInputGroups([{ item: "", available: 100, quantity: "", date: "" }]);
        document.getElementById("registerModalClose")?.click();
        fetchRequisitionList(); // Refresh table data
      } else {
        alert("Failed to save items");
      }
    } catch (error) {
      console.error("API error:", error);
      alert("An error occurred while saving data");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (filterRequisitionDate) {
      fetchRequisitionList(filterRequisitionDate);
    } else {
      fetchRequisitionList();
    }
  };

  const addInputGroup = () => {
    setInputGroups([
      ...inputGroups,
      {
        item: "",
        available: 100,
        quantity: "",
        date: today,
        category_item: "",
      },
    ]);
  };

  const removeInputGroup = (index) => {
    const updated = [...inputGroups];
    updated.splice(index, 1);
    setInputGroups(updated);
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...inputGroups];
    updated[index][field] = value;
    setInputGroups(updated);
  };

  const fetchRequisitionList = (date = "") => {
    const user = JSON.parse(localStorage.getItem("user"));
    const kitchenId = user?.kitchen; // Ensure kitchenId is derived from user

    if (kitchenId) {
      const url = date
        ? `https://ims-backend.indevconsultancy.in/api/requistion-list/?kitchen_id=${kitchenId}&date=${date}&status=2`
        : `https://ims-backend.indevconsultancy.in/api/requistion-list/?kitchen_id=${kitchenId}&status=2`;

      axios
        .get(url)
        .then((response) => {
          if (response.data.requisitiondata) {
            // const parsedData = JSON.parse(response.data.requisitiondata);
            setRequisitionList(response.data.requisitiondata);
            setCurrentPage(1);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch requisition list:", error);
        });
    } else {
      console.warn("Kitchen ID not found in user data");
    }
  };

  const [itemDetailsSaveData, setItemDetailsSaveData] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedDateofReceived, setSelectedDateofReceived] = useState("");

  const handleInputChangeMRN = (index, field, value) => {
    const updatedDetails = [...itemDetails];
    console.log(updatedDetails);

    updatedDetails[index][field] = value;
    setItemDetailsSaveData(updatedDetails);
  };

  const handleSubmitMRN = async () => {
    try {
      const payload = {
        requisition_id: REID1,
        date_of_order: selectedDateofReceived,
        vendor_id: selectedVendorId,
        items: itemDetailsSaveData,
      };
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/sumit-request-items",
        payload
      );
      fetchRequisitionList();
    } catch (error) {
      console.error("Submission failed:", error);
      alert("Error submitting requisition");
    }
  };

  return (
    <div className="container-fluid px-2">
      <div className="content">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between py-2">
            <div className="col-md-6 col-4">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-start mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/mobilehome">Home</Link>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-8 text-end">
              <span className="fs-1">Purchase Order List</span>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header border-info">
                  <form onSubmit={handleSearch}>
                    <div className="row g-3">
                      <div className="col-lg">
                        <input
                          type="date"
                          className="form-control"
                          value={filterRequisitionDate}
                          onChange={(e) => setRequisitionDate(e.target.value)}
                        />
                      </div>

                      <div className="col-lg-2">
                        <button type="submit" className="btn btn-primary w-100">
                          Search
                        </button>
                      </div>
                      <div className="col-lg-1">
                        <button
                          type="button"
                          className="btn btn-outline-dark w-100"
                          onClick={() => {
                            setFilterDate("");
                            fetchRequisitionList();
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="card-body">
                  <div className="row g-0 align-items-center">
                    <div className="col-sm-7 mb-3">
                      <h6 className="fw-bold mb-0">
                        Total Requisition(s):{" "}
                        <span>{requisitionList.length}</span>
                      </h6>
                    </div>
                    <div className="col-sm-5 mb-3 text-end">
                      {/* <button className="btn btn-primary add-item" type="button" data-bs-toggle="modal" data-bs-target="#registerModal">
                                                Add <i className="fas fa-plus"></i>
                                            </button> */}
                    </div>
                  </div>

                  <div className="table-responsive scrollbar">
                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>S.No.</th>
                          <th>Requisition ID</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedList.length === 0 ? (
                          <tr>
                            <td colSpan="5">Loading or no data available</td>
                          </tr>
                        ) : (
                          paginatedList.map((item, index) => {
                            // const { requestdate, status } = item.fields;
                            return (
                              <tr key={item.reqid}>
                                <td>
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td>RE00{item.reqid || item.reqid}</td>
                                <td>
                                  {new Date(
                                    item.requestdate
                                  ).toLocaleDateString()}
                                </td>
                                <td>
                                  <span
                                    className={`badge bg-${
                                      statusColorMap[item.status] || "dark"
                                    }`}
                                  >
                                    {statusMap[item.status] || "Unknown"}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-2 justify-content-center">
                                    <button
                                      className="btn btn-primary add-item btn-sm"
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#viweModal"
                                      onClick={() => {
                                        setSelectedItemId(item.reqid);
                                        fetchRequisitionItemDetails(item.reqid);
                                      }}
                                      title="View"
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                    {/* {status == "0" && (
                                      <button
                                        className="btn btn-primary add-item btn-sm"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editModal"
                                        onClick={() => {
                                          setSelectedREID("RE00" + item.pk)
                                          setSelectedREID1(item.pk)
                                          setSelectedItemId(item.pk);
                                          fetchRequisitionItemDetails(item.pk);
                                        }}
                                        title="Edit">
                                        Edit
                                      </button>
                                    )} */}
                                    {/* {status == "1" && (
                                      <button
                                        className="btn btn-primary add-item btn-sm"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editModal"
                                        onClick={() => {
                                          setSelectedREID("RE00" + item.pk)
                                          setSelectedREID1(item.pk)
                                          setSelectedItemId(item.pk);
                                          fetchRequisitionItemDetails(item.pk);
                                        }}
                                        title="Edit"
                                      >MRN
                                      </button>
                                    )} */}
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination Controls */}
                  {/* {paginatedList.length > 10 && ( */}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="registerModal"
        tabIndex="-1"
        aria-labelledby="registerModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="registerModalLabel">
                  Add Requisition Item
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                {inputGroups.map((group, index) => (
                  <div className="input-group mb-3" key={index}>
                    <select
                      className="form-control"
                      name="category_item[]"
                      value={group.item}
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "category_item",
                          e.target.value
                        )
                      }
                    >
                      <option value="">Select Category</option>
                      {stockOptions.map((stock) => (
                        <option key={stock.stock_id} value={stock.stock_id}>
                          {stock.stock_name} ({stock.units})
                        </option>
                      ))}
                    </select>
                    <select
                      className="form-control"
                      name="item[]"
                      value={group.item}
                      onChange={(e) =>
                        handleInputChange(index, "item", e.target.value)
                      }
                    >
                      <option value="">Select Item</option>
                      {stockOptions.map((stock) => (
                        <option key={stock.stock_id} value={stock.stock_id}>
                          {stock.stock_name} ({stock.units})
                        </option>
                      ))}
                    </select>

                    <span className="input-group-text">Quantity</span>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Quantity"
                      value={group.quantity}
                      onChange={(e) =>
                        handleInputChange(index, "quantity", e.target.value)
                      }
                    />

                    <span className="input-group-text">Date</span>
                    <input
                      type="date"
                      className="form-control"
                      value={
                        group.date || new Date().toISOString().split("T")[0]
                      }
                      onChange={(e) =>
                        handleInputChange(index, "date", e.target.value)
                      }
                    />

                    {index == 0 && (
                      <button
                        className="btn btn-success"
                        type="button"
                        onClick={addInputGroup}
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    )}

                    {index > 0 && (
                      <button
                        className="btn btn-danger"
                        type="button"
                        onClick={() => removeInputGroup(index)}
                      >
                        <i className="fas fa-minus"></i>
                      </button>
                    )}
                  </div>
                ))}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <div className="modal fade" id="editModal" tabIndex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="registerModalLabel">Add MR</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div className="modal-body">
                <div className="input-group mb-3">
                  <span className="input-group-text">Requisition ID</span>
                  <input
                    type="text"
                    value={REID}
                    className="form-control"
                  />
                  <span className="input-group-text">Date of Order</span>
                  <input
                    type="date"
                    className="form-control"
                  />
                  <span className="input-group-text">Select Vendor</span>

                  <select
                    className="form-control"
                    name="item[]"

                  >
                    <option value="">Select Item</option>
                    {stockOptions.map(stock => (
                      <option key={stock.stock_id} value={stock.stock_id}>
                        {stock.stock_name} ({stock.units})
                      </option>
                    ))}
                  </select>
                </div>


                {inputGroups.map((group, index) => (

                  <>

                    <div className="input-group mb-3" key={index}>
                      <select
                        className="form-control"
                        name="item[]"
                        value={group.item}
                        onChange={(e) => handleInputChange(index, 'item', e.target.value)}
                      >
                        <option value="">Select Item</option>
                        {stockOptions.map(stock => (
                          <option key={stock.stock_id} value={stock.stock_id}>
                            {stock.stock_name} ({stock.units})
                          </option>
                        ))}
                      </select>
                      <span className="input-group-text">Amount </span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Amount"
                        value={group.quantity}
                        onChange={(e) => handleInputChange(index, 'quantity', e.target.value)}
                      />

                      <span className="input-group-text">Total Amount</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Total Amount"
                        value={group.date}
                        onChange={(e) => handleInputChange(index, 'date', e.target.value)}
                      />

                      <span className="input-group-text">Quantity</span>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Quantity"
                        value={group.date}
                        onChange={(e) => handleInputChange(index, 'date', e.target.value)}
                      />


                      {index == 0 && (
                        <button
                          className="btn btn-success"
                          type="button"
                          onClick={addInputGroup}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                      )}

                      {index > 0 && (
                        <button
                          className="btn btn-danger"
                          type="button"
                          onClick={() => removeInputGroup(index)}
                        >
                          <i className="fas fa-minus"></i>
                        </button>
                      )}
                    </div></>
                ))}
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div> */}

      <div
        className="modal fade"
        id="editModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Material Received Note (MRN)</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {itemDetails.length === 0 ? (
                <p>No items available</p>
              ) : (
                <>
                  <div className="input-group mb-3">
                    <span className="input-group-text">Requisition ID</span>
                    <input type="text" value={REID} className="form-control" />
                    <span className="input-group-text">Date of Received</span>
                    <input
                      type="date"
                      className="form-control"
                      value={selectedDateofReceived}
                      onChange={(e) =>
                        setSelectedDateofReceived(e.target.value)
                      }
                    />
                    <span className="input-group-text">Select Vendor</span>
                    <select
                      className="form-control"
                      name="item[]"
                      value={selectedVendorId}
                      onChange={(e) => setSelectedVendorId(e.target.value)}
                    >
                      <option value="">Select Vendor</option>
                      {stockVendor.map((stock) => (
                        <option key={stock.vendor_id} value={stock.vendor_id}>
                          {stock.vendor_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>Item Name</th>
                        <th>Required Quantity</th>
                        <th>Received Quantity</th>
                        <th>Amount </th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemDetails.map((detail, index) => (
                        <tr key={index}>
                          <td>{detail.stock}</td>
                          <td>{detail.requestquantity}</td>

                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Received Qty"
                              value={detail.receivedquantity}
                              onChange={(e) =>
                                handleInputChangeMRN(
                                  index,
                                  "receivedquantity",
                                  e.target.value
                                )
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Amount"
                              value={detail.amount}
                              onChange={(e) =>
                                handleInputChangeMRN(
                                  index,
                                  "amount",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={handleSubmitMRN}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="modal fade" id="viweModal" tabIndex="-1" aria-labelledby="registerModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title" id="registerModalLabel">View </h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body py-2">

                                {itemDetails.length === 0 ? (
                                    <p className="text-center text-danger">No data found</p>
                                ) : (
                                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                                        <thead className="bg-primary text-white">
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Stock</th>
                                                <th>Requested</th>
                                                <th>Received</th>
                                                <th>Required Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {itemDetails.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.stock}</td>
                                                    <td>{item.requestquantity}</td>
                                                    <td>{item.recievedquantity}</td>
                                                    <td>{new Date(item.required_date).toLocaleDateString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div> */}
      <div
        className="modal fade"
        id="viweModal"
        tabIndex="-1"
        aria-labelledby="registerModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-scrollable modal-fullscreen-sm-down">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5
                  className="modal-title w-100 text-center text-md-start"
                  id="registerModalLabel"
                >
                  View
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body py-2">
                {itemDetails.length === 0 ? (
                  <p className="text-center text-danger">No data found</p>
                ) : (
                  <div className="table-responsive">
                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th>S.No.</th>
                          <th>Stock</th>
                          <th>Requested</th>
                          <th>Received</th>
                          <th>Required Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemDetails.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.stock}</td>
                            <td>{item.requestquantity}</td>
                            <td>{item.recievedquantity}</td>
                            <td>
                              {new Date(
                                item.required_date
                              ).toLocaleDateString()}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminInvoice;
